module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-16.833dceab.png";